export default __webpack_public_path__ + "static/media/ws-gc-icon.0ada4929.svg";